var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"placeholder":"请选择渠道","clearable":"","props":_vm.props},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }